import { render, staticRenderFns } from "./ActualComponent.vue?vue&type=template&id=1d249be8"
import script from "./ActualComponent.vue?vue&type=script&lang=js"
export * from "./ActualComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports